module.exports = __webpack_public_path__ + "img/gifting-online-dark.e8662fb3.svg";